export default {
      id: "volume-web-1st-usage",
      viewBox: "0 0 46 39",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#volume-web-1st",
      toString: function () {
        return this.url;
      }
    }